import { EmbroiderableProductEmbroideryConfig } from '../../../../types/graphql/product'
import { PlacementId, toPlacementId } from '../../combination-rules/placementIds'
import { EMBROIDERY_TYPES, EmbroideryTypeKey, PlacementRule } from '../../combination-rules/types'

/**
 * Turns a product's catalog embroidery config into the garment anatomy the engine reads. The
 * catalog lists placements per type; this lists types per placement.
 *
 *     in    text: [CHEST:RIGHT, CHEST:LEFT], logo: [CHEST:LEFT]
 *     out   [{ id: 'CHEST:RIGHT', allowedTypes: ['text'] },
 *            { id: 'CHEST:LEFT', allowedTypes: ['text', 'logo'] }]
 *
 * A placement keeps the order of the first type to list it, so this is no one type's catalog order.
 */
export const deriveAnatomy = (
  productEmbroideryConfig: EmbroiderableProductEmbroideryConfig | null | undefined
): PlacementRule[] => {
  if (!productEmbroideryConfig) return []

  const allowedTypesByPlacementId = new Map<PlacementId, Set<EmbroideryTypeKey>>()

  for (const typeKey of EMBROIDERY_TYPES) {
    for (const placement of productEmbroideryConfig.options[typeKey]?.placements ?? []) {
      const placementId = toPlacementId(placement.location, placement.position)
      const allowedTypes =
        allowedTypesByPlacementId.get(placementId) ?? new Set<EmbroideryTypeKey>()
      allowedTypes.add(typeKey)
      allowedTypesByPlacementId.set(placementId, allowedTypes)
    }
  }

  return [...allowedTypesByPlacementId].map(([id, allowedTypes]) => ({
    id,
    allowedTypes: [...allowedTypes],
  }))
}
